import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import {
  useStylesTF,
  useStylesTD,
  useStylesSetting,
} from "../../../St/comps/UseStyle";
import { useEffect } from "react";
import { Button } from "@material-ui/core";
import Swipeable from "../../../Fronts/Main/Swipeable";
import axios from "axios";
import toast from "react-hot-toast";
import { uri } from "../../../help/Api";
import { useTranslation } from "react-i18next";

export default function DFSettingsForm(props) {
  const { object, data, onChange } = props;
  const { t } = useTranslation(["forms"]);

  const [submiting, setSubmiting] = useState(false);

  const applyTaxGroup = async (taxGroupId) => {
    console.log(taxGroupId);
    const data = { id: taxGroupId };
    setSubmiting(true);
    await axios
      .post(uri + "SysSettings", data)
      .then((res) => {
        toast.success(t("default-tax-applied"));
      })
      .catch((err) => {
        toast.error(t("apply-failed"));
        console.log(err);
      });

    setSubmiting(false);
  };

  const classesStt = useStylesSetting();

  return (
    <React.Fragment>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object?.branch}
          onChange={(event, newValue) => {
            onChange(null, { name: "branch", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={data?.branches}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}

          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={t("default-branch")}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object.safe}
          onChange={(event, newValue) => {
            onChange(null, { name: "safe", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={data?.safes}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}

          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={t("default-safe")}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object.stock}
          onChange={(event, newValue) => {
            onChange(null, { name: "stock", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={data?.stocks}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}

          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={t("default-cashbox")}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object?.unit}
          onChange={(event, newValue) => {
            onChange(null, { name: "unit", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={data?.units}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}

          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={t("default-unit")}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid container item lg={12} md={12} xs={12}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <Autocomplete // classes={clasAo}
            value={object?.taxGroup}
            onChange={(event, newValue) => {
              onChange(null, { name: "taxGroup", value: newValue });
            }}
            id="controllable-states-dem"
            size="small"
            options={data?.taxGroups}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.nameAR
            }
            //style={{  }}  // disabled={}

            disableClearable
            renderInput={(params) => (
              <TextField
                id="valuePricePay"
                {...params}
                label={t("default-tax-group")}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <Button
            variant="contained"
            className={classesStt.btn}
            color="primary"
            fontSize="large"
            onClick={() => {
              if (object?.taxGroup?.id) applyTaxGroup(object?.taxGroup?.id);
            }}
            disabled={submiting}
          >
            {submiting
              ? t("applying-tax")
              : t("apply-tax-to-items")}
          </Button>
        </Grid>
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Autocomplete // classes={clasAo}
          value={object?.omla}
          onChange={(event, newValue) => {
            onChange(null, { name: "omla", value: newValue });
          }}
          id="controllable-states-dem"
          size="small"
          options={data?.omlat}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.name
          }
          //style={{  }}  // disabled={}

          disableClearable
          renderInput={(params) => (
            <TextField
              id="valuePricePay"
              {...params}
              label={t("default-currency")}
              variant="outlined"
              size="small"
            />
          )}
        />
      </Grid>
    </React.Fragment>
  );
}
